export default "__VITE_ASSET__BzK27wPY__"